import { Component, OnInit } from '@angular/core';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { EchantillonageService } from 'src/app/services/echantillonage.service';

@Component({
  selector: 'app-echantillonage',
  templateUrl: './echantillonage.component.html',
  styleUrls: ['./echantillonage.component.css']
})
export class EchantillonageComponent implements OnInit {

  
  
  constructor() {} 

  ngOnInit(): void {
    
  }


  

}
